import AxiosInstanceCreator from 'services/api';
import { MeissaResponse } from '../models/maps.model.ts';
import { BaseApiResponse } from '../../common';

const meissa = '/meissa';

const meissaInstance = new AxiosInstanceCreator().create();

export const meissaApi = {
  token: async (): Promise<BaseApiResponse<MeissaResponse>> => {
    const response = await meissaInstance.get(`${meissa}/token`);

    return response.data;
  }
};
